import { useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { toast } from "sonner";
import { Wordmark } from "./Wordmark";
import { api } from "../lib/api";

export const Footer = () => {
  const [email, setEmail] = useState("");

  const subscribe = async (e) => {
    e.preventDefault();
    try {
      await api.post("/newsletter", { email });
      toast.success("Te-ai abonat", { description: "Vei primi noutăți Cassia Concept." });
      setEmail("");
    } catch {
      toast.error("Adresă de email invalidă");
    }
  };

  return (
    <footer data-testid="site-footer" className="surface border-t border-black/5 mt-24">
      <div className="container-cc py-16 lg:py-24 grid grid-cols-1 lg:grid-cols-12 gap-12">
        <div className="lg:col-span-4">
          <Wordmark size="lg" />
          <p className="mt-6 text-sm text-[#5A5A5A] leading-relaxed max-w-sm">
            Boutique online dedicat exclusiv cărucioarelor, remorcilor și scaunelor auto THULE. Design scandinav, siguranță și libertate de mișcare pentru familiile urbane.
          </p>
          <div className="mt-6 flex items-center gap-3">
            <span className="eyebrow">Brand prezentat</span>
            <img src="/thule-logo.png" alt="Thule Sweden" data-testid="footer-thule-logo" className="h-6 w-auto" />
          </div>
        </div>
        <div className="lg:col-span-2">
          <p className="eyebrow mb-5">Colecții</p>
          <ul className="space-y-3 text-sm">
            <li><Link className="link-underline" to="/catalog/carucioare">Cărucioare urbane</Link></li>
            <li><Link className="link-underline" to="/catalog/sport">Cărucioare sport</Link></li>
            <li><Link className="link-underline" to="/catalog/multisport">Remorci multisport</Link></li>
            <li><Link className="link-underline" to="/catalog/scaune-auto">Scaune auto</Link></li>
            <li><Link className="link-underline" to="/catalog/purtare">Rucsacuri transport</Link></li>
          </ul>
        </div>
        <div className="lg:col-span-2">
          <p className="eyebrow mb-5">Informații</p>
          <ul className="space-y-3 text-sm">
            <li><Link className="link-underline" to="/despre" data-testid="footer-despre">Despre noi</Link></li>
            <li><Link className="link-underline" to="/contact" data-testid="footer-contact">Contact</Link></li>
            <li><Link className="link-underline" to="/termeni" data-testid="footer-termeni">Termeni și condiții</Link></li>
            <li><Link className="link-underline" to="/confidentialitate" data-testid="footer-confidentialitate">Confidențialitate</Link></li>
            <li><Link className="link-underline" to="/cookies" data-testid="footer-cookies">Politica cookies</Link></li>
          </ul>
        </div>
        <div className="lg:col-span-4">
          <p className="eyebrow mb-5">Newsletter</p>
          <p className="text-sm text-[#5A5A5A] mb-4">Noutăți din colecțiile THULE și lansări de sezon.</p>
          <form onSubmit={subscribe} className="flex border-b border-[#0A0A0A]">
            <input
              data-testid="newsletter-input"
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="adresa@email.ro"
              className="flex-1 bg-transparent h-12 text-sm focus:outline-none placeholder:text-neutral-400"
            />
            <button data-testid="newsletter-submit" aria-label="Abonează-te" className="icon-btn">
              <ArrowRight size={18} strokeWidth={1.5} />
            </button>
          </form>
        </div>
      </div>
      <div className="border-t border-black/5">
        <div className="container-cc py-6 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3 text-[11px] uppercase tracking-[0.18em] text-[#737373]">
          <span>© {new Date().getFullYear()} Cassia Concept · Demo de prezentare</span>
          <span>THULE este marcă înregistrată a Thule Group. Datele firmei vor fi completate ulterior.</span>
        </div>
      </div>
    </footer>
  );
};
